<template>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Sign In</h4>
                  <p class="mb-0">
                    Enter your username and password to sign in
                  </p>
                </div>
                <div class="card-body">
                  <VeeForm @submit="onSubmit">
                    <dynamic-form :schema="formSchema" :formData="formData" />

                    <argon-switch id="rememberMe">Remember me</argon-switch>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="info"
                        fullWidth
                        size="lg"
                        >Sign in</argon-button
                      >
                    </div>
                  </VeeForm>
                </div>
                <div class="px-1 pt-0 text-center card-footer px-lg-2">
                  <p class="mx-auto mb-4 text-sm">
                    Don't have an account?
                    <a
                      href="javascript:;"
                      class="text-success text-gradient font-weight-bold"
                      >Sign up</a
                    >
                  </p>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url(&quot;https://www.tlacc.org/wp-content/uploads/2021/09/ETHNIX-GROUP.png&quot;);
                  background-size: 90%;
                  background-position: center;
                  background-repeat: no-repeat;
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import { Form as VeeForm } from "vee-validate";
import {
  defineComponent,
  computed,
  watch,
  onMounted,
  ref,
  onUnmounted,
} from "vue";
import { useStore } from "vuex";
import { loginForm as formSchema } from "@/constants/formSchemes";
import { useRouter } from "vue-router";
import DynamicForm from "@/components/DynamicForm.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
const body = document.getElementsByTagName("body")[0];
export default defineComponent({
  name: "signinComponent",
  components: {
    VeeForm,
    ArgonSwitch,
    ArgonButton,
    DynamicForm,
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const formData = ref({
      id: 0,
      name: "",
      description: "",
    });

    const loading = computed(() => store.state.auth.loading);
    const isSucceeded = computed(() => store.state.auth.isSucceeded);

    const onSubmit = (values, { resetForm }) => {
      store.dispatch("auth/signin", values);
      resetForm();
    };

    watch(loading, (newValue) => {
      if (!newValue && isSucceeded.value) {
        router.push({ name: "Accounts" });
      }
    });

    onMounted(() => {
      store.state.hideConfigButton = true;
      store.state.showNavbar = false;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onUnmounted(() => {
      store.state.hideConfigButton = false;
      store.state.showNavbar = true;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });

    return {
      formSchema,
      formData,
      onSubmit,
    };
  },
});
</script>
